(function( $ ) {

	$(document).on('change', '.queue-list-header input[type="checkbox"]', function(e){
		e.preventDefault();
		if($(this).is(':checked')){
			$(this).closest('.queue-list-header').next('.queue-list').find('input[type="checkbox"]').each(function(){
				$(this).prop('checked', true);
			});
		} else{
			$(this).closest('.queue-list-header').next('.queue-list').find('input[type="checkbox"]').each(function(){
				$(this).prop('checked', false);
			});
		}
	});
 
	$('.queue-list').find('input[type="checkbox"]').each(function(){
		$(this).on('change', function(e){
			e.preventDefault(); 
			if(! $(this).is(':checked')){
				$(this).closest('.queue-list').prev('.queue-list-header').find('input[type="checkbox"]').prop('checked', false);
			}
		});
	});

}(jQuery));